import PropTypes from 'prop-types';
import { ICON_BUTTON_ICONS } from '../../../buttons/IconButton';

/**
 * The note for a company without a majority shareholder, below the Ultimate shareholders table
 * and the levels table of the Shareholders tab.
 *
 * @param {Object} props
 * @param {string} [props.companyName] - the company the note names
 */
const IndependentShareholderNote = ({ companyName = '' }) => (
  <div className="independent-info-wrapper">
    <div className="independent-info-icon-wrap">
      <img src={ICON_BUTTON_ICONS.INFO_CIRCLE} alt="Info" />
    </div>
    <div className="independent-info-text">
      {`${companyName} has no direct majority shareholder of >50.0%`}
    </div>
  </div>
);

IndependentShareholderNote.propTypes = {
  companyName: PropTypes.string
};

export default IndependentShareholderNote;
